import { useQuery } from '@tanstack/react-query';
import axiosAuth from '../utils/axiosAuth';

/**
 * Hook to fetch and cache user's subscription status
 * Returns null if no active subscription
 */
export const useSubscription = (userId, options = {}) => {
  return useQuery({
    queryKey: ['subscription', userId],
    
    queryFn: async () => {
      console.log('🔍 [useSubscription] Fetching subscription status from API');
      
      const response = await axiosAuth.get('/api/subscription/status');
      
      if (!response.data.success) {
        throw new Error(response.data.error || 'Failed to fetch subscription');
      }
      
      const subscription = response.data.subscription;
      
      if (subscription) {
        console.log('✅ [useSubscription] Active subscription:', subscription.plan);
      } else {
        console.log('ℹ️ [useSubscription] No active subscription');
      }
      
      return subscription; // null if no active subscription
    },
    
    // Only run if user is authenticated
    enabled: !!userId && (options.enabled !== false),
    
    // Cache settings: balance freshness with performance
    staleTime: 5 * 60 * 1000,      // 5 minutes - subscription data doesn't change often
    cacheTime: 10 * 60 * 1000,     // 10 minutes - keep in memory
    
    // Always show cached data first for instant UI
    keepPreviousData: true,
    
    // Refetch strategies
    refetchOnMount: 'always',      // Check for updates on mount
    refetchOnWindowFocus: true,    // Refetch when window gains focus
    refetchOnReconnect: true,      // Refetch when network reconnects
    
    // Logging
    onSuccess: (data) => {
      if (data) {
        console.log('✅ [useSubscription] Loaded subscription from cache:', {
          plan: data.plan,
          status: data.status,
          renewalDate: data.currentPeriodEnd
        });
      }
    },
    
    onError: (error) => {
      console.error('❌ [useSubscription] Failed to load subscription:', error);
    }
  });
};

